'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { uniqueId } from 'lodash';
import Image from 'next/image';
import { type HeroLabelInputProps } from './HeroBanner.builder';
export const HeroLabels = t0 => {
  const $ = _c(19);
  const {
    logoLandscape,
    logoLandscapeAlt,
    logoPortrait,
    logoPortraitAlt,
    textVariantLandscape: t1,
    textVariantPortrait: t2,
    builderBlock,
    ctaItems,
    headerItems
  } = t0;
  const textVariantLandscape = t1 === undefined ? "light" : t1;
  const textVariantPortrait = t2 === undefined ? "light" : t2;
  const textVariantLandscapeColor = textVariantLandscape === "light" ? "md:text-bodi-white" : "md:text-bodi-black";
  const textVariantPortraitColor = textVariantPortrait === "light" ? "text-bodi-white" : "text-bodi-black";
  let t3;
  if ($[0] !== logoLandscape || $[1] !== logoLandscapeAlt || $[2] !== logoPortrait || $[3] !== logoPortraitAlt) {
    t3 = (logoLandscape ?? logoPortrait) && <><Image className="lg:hidden" src={logoPortrait ?? logoLandscape ?? ""} alt={logoPortraitAlt ?? ""} width={191} height={37} /><Image className="hidden lg:block" src={logoPortrait ?? logoLandscape ?? ""} alt={logoLandscapeAlt ?? ""} width={191} height={37} /></>;
    $[0] = logoLandscape;
    $[1] = logoLandscapeAlt;
    $[2] = logoPortrait;
    $[3] = logoPortraitAlt;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== builderBlock?.id || $[6] !== headerItems || $[7] !== textVariantLandscapeColor || $[8] !== textVariantPortraitColor) {
    t4 = headerItems?.map((item, index) => <BuilderBlocks key={uniqueId()} parentElementId={builderBlock?.id} className={`${textVariantLandscapeColor} ${textVariantPortraitColor} z-10`} dataPath={`component.options.headerItems.${index}.headerItem`} blocks={item.headerItem} style={{
      minHeight: "auto !important"
    }} />);
    $[5] = builderBlock?.id;
    $[6] = headerItems;
    $[7] = textVariantLandscapeColor;
    $[8] = textVariantPortraitColor;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== builderBlock?.id || $[11] !== ctaItems) {
    t5 = ctaItems?.map((item_0, index_0) => <div key={uniqueId()} className="w-full md:w-auto"><BuilderBlocks parentElementId={builderBlock?.id} dataPath={`component.options.ctaItems.${index_0}.ctaItem`} blocks={item_0.ctaItem} style={{
        minHeight: "auto !important"
      }} className="w-full md:w-auto" /></div>);
    $[10] = builderBlock?.id;
    $[11] = ctaItems;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="z-10 flex w-full flex-row gap-3 md:w-auto">{t5}</div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className="z-10 flex w-full px-5 py-20 pb-16 md:max-w-xl md:px-16"><div className="flex w-full flex-col justify-center gap-6 pb-5">{t3}{t4}{t6}</div></div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};